export default __webpack_public_path__ + "static/media/breakfast-overlay@3x.a7b78a1a.png";